import React from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';

import { Container } from './styles';
import { DialogProps } from './types';

const DialogContainer = ({
  open,
  children,
  onClose,
  ...props
}: DialogProps) => {
  const transitionRef = React.useRef(null);

  return (
    <CSSTransition
      in={open}
      timeout={100}
      unmountOnExit
      nodeRef={transitionRef}
      {...props}
    >
      <Container className="dialog" ref={transitionRef}>
        <div
          className="dialog-overlay"
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            if (onClose) onClose();
          }}
        />
        <div className="dialog-content">{children}</div>
      </Container>
    </CSSTransition>
  );
};

export const Dialog = ({ open, ...props }: DialogProps) => {
  if (!open) return null;
  return ReactDOM.createPortal(
    <DialogContainer open={open} {...props} />,
    document.body
  );
};
